<template>

  <router-link
      v-if="navPermissions['reports'].enable"
      is="router-link"
      class="nav-item"
      to="/reports"
  >
    <a class="sidebar-menu-item nav-link">
      <template>
        <i class="fa fa-file-invoice text-danger pr-2"></i>
        <span class="nav-link-text">
                    Reports
                </span>
      </template>
    </a>
  </router-link>
</template>
<script>
import initService from "@/common/api-services/init-service";

export default {
  name: 'side-reports-basic-group',
  data() {
    return {
      isPortalAdminStatus: false,
      isAdminStatus: false,
      groups: [],
      navPermissions: {
        "reports": {
          enable: false,
          role: ["REPORTS_READ", "Administrator"]
        }
      }
    }
  },
  mounted() {
    this.isPortalAdminStatus = initService.getPortalAdminRole();
    this.isAdminStatus = initService.getAdministratorRole() || initService.getPortalAdminRole();
    this.groups = initService.getGroups();
    Object.keys(this.navPermissions).map(item => {
      this.groups.map(it => {
        if (this.navPermissions[item].role.includes(it)) this.navPermissions[item].enable = true;
      });
    });
  }
}
</script>